import { useState } from "react";
import { X, Eye } from "lucide-react";
import DOMPurify from "dompurify";

var GROUP_OPTIONS = [
  { value: "todos", label: "Todos os clientes e leads" },
  { value: "consorcio", label: "Clientes de Consórcio" },
  { value: "seguros", label: "Clientes de Seguros" },
  { value: "plano_saude", label: "Clientes de Plano de Saude" },
  { value: "leads_abertos", label: "Leads que nao fecharam" },
  { value: "individual", label: "Destinatarios individuais" },
];

export default function ComposeEmail({ onSend, onCancel, templates, loading }) {
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [group, setGroup] = useState("todos");
  const [individuals, setIndividuals] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [showPreview, setShowPreview] = useState(false);

  function handleTemplateSelect(tid) {
    setSelectedTemplate(tid);
    if (!tid) return;
    var t = templates.find(function(x) { return x.id === tid; });
    if (t) { setSubject(t.subject); setBody(t.body_html); }
  }

  function handleSend() {
    if (!subject.trim() || !body.trim()) return;
    var indList = group === "individual" ? individuals.split(",").map(function(e) { return e.trim(); }).filter(Boolean) : null;
    onSend({ subject: subject, body_html: body, recipient_group: group, individual_recipients: indList });
  }

  return (
    <div className="bg-white rounded-xl lg:rounded-2xl shadow-sm">
      <div className="p-5 border-b border-gray-100">
        <h3 className="text-base font-bold text-[#0A2F3D]">Novo E-mail</h3>
      </div>
      <div className="p-5 space-y-4">
        {templates.length > 0 && (
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1.5">Usar template</label>
            <select value={selectedTemplate} onChange={function(e) { handleTemplateSelect(e.target.value); }}
              className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30"
              data-testid="compose-template-select">
              <option value="">Escrever do zero</option>
              {templates.map(function(t) { return <option key={t.id} value={t.id}>{t.title}</option>; })}
            </select>
          </div>
        )}
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1.5">Destinatarios *</label>
          <select value={group} onChange={function(e) { setGroup(e.target.value); }}
            className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30"
            data-testid="compose-group-select">
            {GROUP_OPTIONS.map(function(g) { return <option key={g.value} value={g.value}>{g.label}</option>; })}
          </select>
        </div>
        {group === "individual" && (
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1.5">E-mails (separados por virgula)</label>
            <textarea value={individuals} onChange={function(e) { setIndividuals(e.target.value); }}
              className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm resize-none focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30"
              rows="2" placeholder="email1@exemplo.com, email2@exemplo.com" data-testid="compose-individuals" />
          </div>
        )}
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1.5">Assunto *</label>
          <input type="text" value={subject} onChange={function(e) { setSubject(e.target.value); }}
            className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30"
            placeholder="Assunto do e-mail" data-testid="compose-subject" />
        </div>
        <div>
          <div className="flex items-center justify-between mb-1.5">
            <label className="text-xs font-medium text-gray-600">Corpo do e-mail (HTML) *</label>
            <button onClick={function() { setShowPreview(!showPreview); }}
              className="flex items-center gap-1 text-xs text-[#3B82F6] hover:underline" data-testid="compose-preview-toggle">
              <Eye className="w-3 h-3" /> {showPreview ? "Editar" : "Preview"}
            </button>
          </div>
          {showPreview ? (
            <div className="border border-gray-200 rounded-xl p-4 min-h-[200px] bg-gray-50 overflow-auto" data-testid="compose-preview">
              <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(body.replace(/\{\{nome\}\}/g, "Joao da Silva")) }} />
            </div>
          ) : (
            <textarea value={body} onChange={function(e) { setBody(e.target.value); }}
              className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm font-mono resize-none focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30"
              rows="10" placeholder="<p>Ola, {{nome}}!</p>..." data-testid="compose-body" />
          )}
          <p className="text-xs text-gray-400 mt-1">Variaveis disponiveis: {"{{nome}}"}, {"{{descricao}}"}, {"{{valor}}"}, {"{{vencimento}}"}, {"{{metodo}}"}</p>
        </div>
        <div className="flex gap-3 pt-2">
          <button onClick={onCancel} className="flex-1 px-4 py-2.5 border border-gray-200 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-50">Cancelar</button>
          <button onClick={handleSend} disabled={loading || !subject.trim() || !body.trim()}
            className="flex-1 px-4 py-2.5 bg-[#3B82F6] text-white rounded-xl text-sm font-medium hover:bg-[#2563EB] disabled:opacity-50"
            data-testid="compose-send-button">
            {loading ? "Enviando..." : "Enviar E-mail"}
          </button>
        </div>
      </div>
    </div>
  );
}
